import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CatalogBreadcrumb, CatalogMetadata, CategoryCard } from '@/components/catalog'
import { NotFound } from '@/components/layout/SiteShell'
import { publicCategories, publicProducts } from '@/data/public-catalog'
import { getLocalizedPath, languageFromPath } from '@/i18n/routes'

export function SolutionsPage() {
  const { t } = useTranslation('common')
  const location = useLocation()
  const language = languageFromPath(location.pathname)
  const canonicalPath = getLocalizedPath('solutions', language)
  if (location.pathname.replace(/\/$/, '') !== canonicalPath) return <NotFound />
  return <div className="catalog-page catalog-hub">
    <CatalogMetadata
      language={language}
      title={t('catalog.solutionsTitle')}
      description={t('catalog.solutionsMetaDescription')}
      canonicalPath={canonicalPath}
      alternatePaths={{ it: getLocalizedPath('solutions', 'it'), en: getLocalizedPath('solutions', 'en') }}
    />
    <header className="catalog-page-header internal-hero">
      <div className="shell-container">
        <CatalogBreadcrumb />
        <div className="catalog-heading-grid">
          <h1 tabIndex={-1}>{t('catalog.solutionsTitle')}</h1>
          <p>{t('catalog.solutionsIntro')}</p>
        </div>
      </div>
    </header>
    <section className="shell-container catalog-section" aria-labelledby="catalog-categories-title">
      <div className="catalog-section-heading">
        <h2 id="catalog-categories-title">{t('catalog.categoriesTitle')}</h2>
        <p>{t('catalog.categoriesIntro')}</p>
      </div>
      <div className="catalog-category-grid">
        {publicCategories.map(category => <CategoryCard key={category.id} category={category} productCount={publicProducts.filter(product => product.categoryId === category.id).length} />)}
      </div>
    </section>
  </div>
}
